import { render } from "./BelizeonTopFooter.vue?vue&type=template&id=74ce58ce"
import script from "./BelizeonTopFooter.vue?vue&type=script&lang=js"
export * from "./BelizeonTopFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__